import React from "react";
import "../pages/GramsevakPage.css";

const GramsevakPage = () => {
  return (
    <div className="page-container">
      <h2 className="page-title">ग्रामपंचायत अधिकारी</h2>

      {/* ✅ Secretary Information Box */}
      <div className="secretary-box">
        <h3 className="secretary-title">ग्रामपंचायत अधिकारी माहिती</h3>
        <p><b>नाव :</b> "श्री साहेबराव शंभरकर"</p>
        <p><b>पद :</b> ग्रामपंचायत अधिकारी</p>
        <p><b>मोबाईल :</b> 7350823378</p>
      </div>



      <div className="content-box">
        <p className="para">
          आम्ही ग्रामपंचायतीचे <b> ग्रामपंचायत अधिकारी</b> म्हणून कार्यरत आहोत.
          ग्रामसेवक हे पद महाराष्ट्र ग्रामपंचायत अधिनियम, १९५८ नुसार स्थापित केले गेले असून,
          आम्ही ग्रामपंचायतीचे पदसिद्ध सचिव आणि प्रशासकीय प्रमुख म्हणून जबाबदारी सांभाळतो.
        </p>

        <h3 className="section-title">आमची भूमिका आणि कार्य</h3>

        <ul className="service-list">
          <li>
            <b>📌 प्रशासकीय दुवा:</b>
            आम्ही राज्य शासन / जिल्हा परिषद आणि ग्रामपंचायत यांच्यातील महत्त्वाचा दुवा आहोत.
            शासनाच्या योजना गावापर्यंत पोहोचवणे आणि ग्रामपंचायतीचे कामकाज सुरळीत चालवणे हे आमचे मुख्य कार्य आहे.
          </li>

          <li>
            <b>📌 अंमलबजावणी आणि नियोजन:</b>
            ग्रामसभेमध्ये आणि ग्रामपंचायतीच्या बैठकांमध्ये घेतलेल्या ठरावांची अंमलबजावणी करणे,
            तसेच गावाच्या विकासकामांचे योग्य नियोजन करणे ही आमची प्रमुख जबाबदारी आहे.
          </li>

          <li> 
            <b>📌 आर्थिक व्यवस्थापन:</b>
            ग्रामपंचायतीचे अर्थकारण, करवसुली, अंदाजपत्रक तयार करणे,
            आणि सर्व आर्थिक हिशोब व्यवस्थित सांभाळणे हे आमचे कर्तव्य आहे.
          </li>

          <li>
            <b>📌 नोंदणी आणि अभिलेख:</b>
            गावातील जन्म, मृत्यू, विवाह इत्यादी नोंदी तसेच ग्रामपंचायतीचे सर्व अभिलेख
            योग्यरित्या जतन करणे ही आमची जबाबदारी आहे.
          </li>

          <li>
            <b>📌 जनतेला मदत:</b>
            शासनाच्या विविध योजनांची माहिती गावकऱ्यापर्यंत पोहोचवणे,
            प्रमाणपत्रे आणि आवश्यक कागदपत्रांसाठी मदत करणे ही आमची सेवा आहे.
          </li>
        </ul>

        <p className="para">
          आमचा उद्देश हाच आहे की, <b>पारदर्शक</b> आणि <b>गतिमान</b>
          प्रशासनाद्वारे गावाचा सर्वांगीण विकास साधणे
          आणि प्रत्येक नागरिकाला उत्तम सुविधा उपलब्ध करून देणे.
        </p>
      </div>
    </div>
  );
};

export default GramsevakPage;